// Tier-3 builder presentation seam (Phase 7A).
//
// The rest-interval stepper. The canonical rest business rules -- the fixed
// `REST_OPTIONS` ladder and `getNextRestValue`'s clamped forward/backward
// stepping -- stay in the container. This component only renders the two
// steppers and the current label, and calls back with the direction.
export default function RestControl({ value, disabled = false, onStep }) {
  return (
    <div className="lz-builder-stepper">
      <button
        type="button"
        disabled={disabled}
        onClick={() => onStep(-1)}
        className="lz-builder-stepper__button"
        aria-label="Decrease rest interval"
      >
        <span aria-hidden="true">&minus;</span>
      </button>
      <span className="lz-builder-stepper__value">{value}</span>
      <button
        type="button"
        disabled={disabled}
        onClick={() => onStep(1)}
        className="lz-builder-stepper__button"
        aria-label="Increase rest interval"
      >
        <span aria-hidden="true">+</span>
      </button>
    </div>
  );
}
